export default {
  unavailable: {
    title: 'This service is operated by Foodamigos',
    description:
      'Flyer and sticker printing is a service operated by the Foodamigos team and is not available for partner accounts.',
  },
};
